import React, { FC } from 'react';
import styles from './styles.module.scss';
import { Progress } from 'antd';
import { I18n } from 'react-redux-i18n';

interface Props {
  percent: number;
}

const ProgressCard: FC<Props> = ({ percent }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        <b>{I18n.t('onboarding.card.title')}</b>
        <div>{I18n.t('onboarding.card.info')}</div>
      </div>
      <Progress type="circle" percent={percent} width={60} />
    </div>
  );
};

export default ProgressCard;
